import React from 'react';
import { connect } from 'react-redux';
import { GiftPdpDispatch, GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { SizeChoice } from '@gift-variable-plugins/size-attribute-shared/SizeAttributeOptions';
import { selectComponentById, selectHasPreview, selectSizeChoiceById, selectSizeChoicesById, updateValueByIds } from './_redux';
import { SizeAttributeDropdown } from './dropdown/SizeAttributeDropdown';
import { SizeAttributeRadioGroup } from './radio-group/SizeAttributeRadioGroup';

const _SizeAttributeInputControl = ({ component, ...props }: Props) => {
    if (component === 'dropdown') {
        return <SizeAttributeDropdown {...props} />;
    } else {
        return <SizeAttributeRadioGroup {...props} />;
    }
};

type Props = {
    selected: SizeChoice;
    choices: SizeChoice[];
    update: (value: string) => void;
    variableIds: string[];
    component?: 'dropdown' | 'radio-group';
    hasPreview: boolean;
};

const mapStateToProps = (state: GiftPdpState, ownProps: { variableIds: string[] }) => ({
    choices: selectSizeChoicesById(state, ownProps.variableIds[0])!,
    selected: selectSizeChoiceById(state, ownProps.variableIds[0])!,
    component: selectComponentById(state, ownProps.variableIds[0]),
    hasPreview: selectHasPreview(state, ownProps.variableIds[0])
});

const mapDispatchToProps = (dispatch: GiftPdpDispatch, ownProps: { variableIds: string[] }) => ({
    update: (size: string) => dispatch(updateValueByIds(ownProps.variableIds, size))
});

export const SizeAttributeInputControl = connect(
    mapStateToProps,
    mapDispatchToProps
)(_SizeAttributeInputControl);